import moment from 'moment';
import Vue from 'vue';
import postEditor from '../../../components/post-editor.vue';
import loadModal from '../../../components/load-modal.vue';

export default () => {
  const view = document.querySelector('.posts-new');

  new Vue({
    el: '.posts-new',
    data: {
      canUnload: false,
      postId: null,
      lastSavedAt: null,
    },
    mounted() {
      window.onbeforeunload = (e) => {
        if (!this.canUnload) {
          return '変更が保存されない可能性があります。';
        }
      };
      bus.$on('editorInitialized', () => {
        this.canUnload = true;
      });
      bus.$on('editorUpdated', () => {
        this.canUnload = false;
      });
      // setInterval(this.autoSave, 1000*20);
    },
    components: {
      'post-editor': postEditor,
      'load-modal': loadModal,
    },
    methods: {
      moment,
      getBodyJSON() {
        const editor = this.$refs.editor;
        return editor.bodyJSON;
      },
      onScrollTop() {},
      onPreview() {},
      async autoSave() {
        const editor = this.$refs.editor;
        const title = editor.title;
        if (!title) return;

        try {
          await this.savePost();
          this.lastSavedAt = new Date();
          setTimeout(() => {
            this.lastSavedAt = null;
          }, 3000);
        } catch (e) {
          console.log('autosave failed');
        }
      },
      async savePost() {
        const editor = this.$refs.editor;
        const data = {
          title: editor.title,
          comment: editor.comment,
          body: this.getBodyJSON(),
          thumbnail: editor.thumbnail_url,
          thumbnail_quote_url: editor.thumbnail_quote_url,
          tag_ids: editor.tagIds,
          creator_id: editor.creator_id,
          goal_keywords: editor.goalKeywords.join(','),
          suggest_keywords: editor.suggestKeywords.join(','),
          nosplit: editor.nosplit,
        };
        if (this.postId) {
          return await $.ajax({
            url: `/writers/posts/${this.postId}`,
            method: 'PATCH',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
          });
        } else {
          const res = await $.ajax({
            url: '/writers/posts',
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(data),
          });
          this.postId = res.id;
          return res;
        }
      },
      async handleSave() {
        this.canUnload = true;
        const loadModal = this.$refs.loadModal;
        loadModal.loading = true;
        try {
          const res = await this.savePost();
          loadModal.loading = false;
          loadModal.success = true;
          setTimeout(() => {
            location.href = `/writers/posts/${res.id}/edit`;
          }, 1000);
        } catch (e) {
          loadModal.loading = false;
          loadModal.error = true;
          setTimeout(() => {
            loadModal.error = false;
          }, 1000);
        }
      },
    },
  });
};
